import { DivProps } from '../../../../../typings';
import { MainBlock } from './styles';
import React from 'react';
import UDText from '../../../../ud-ui/components/text';

interface IProps extends DivProps {
  isActive: boolean;
  isDisabled?: boolean;
  widthPercent?: number; // optional; defaults to 100%
  compact?: boolean; // renders a smaller, denser variant
  name: string;
  date?: {
    from?: string;
    to?: string;
  };
  price: number;
}

function PlanCard(props: IProps) {
  const { isActive, widthPercent = 100, name, date, price, isDisabled, compact, ...restProps } = props;

  return (
    <MainBlock width={widthPercent} isActive={isActive} isDisabled={isDisabled} $compact={compact} {...restProps}>
      <UDText type={'subhead'}>{name}</UDText>
      <UDText type={'caption-1'} style={{ flexGrow: 1, color: '#8D8D8D', textAlign: 'center' }}>
        {date?.from && `от ${date?.from}`} {date?.to && `до ${date?.to}`}
      </UDText>
      <UDText type={'subhead'} className={'bold'}>
        {price} руб.
      </UDText>
    </MainBlock>
  );
}

export default PlanCard;
